import {
  type CreditMovieCast,
  type CreditMovieCrew,
  type CreditTvCast,
  type CreditTvCrew,
} from '@tmdb-graphql-api/schema/types';

export const castExclusionList = (credit: CreditMovieCast | CreditTvCast) =>
  !credit.character ||
  credit.character.toLowerCase().includes('self') ||
  credit.character.toLowerCase().includes('guest') ||
  credit.character.toLowerCase().includes('archive footage') ||
  credit.character.toLowerCase().includes('archival footage');

export const crewExclusionList = (credit: CreditMovieCrew | CreditTvCrew) =>
  !credit.job || credit.job === 'Thanks' || credit.job === 'In Memory Of';
